import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-1"><path d="M2.75 7.75V4.75H21.25V7.75M2.75 7.75H21.25M2.75 7.75V10.75M21.25 7.75V10.75M21.25 10.75V19.25H2.75V10.75M21.25 10.75H15.25V13.25H8.75V10.75H2.75" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconWallet1;
